import React, { useState } from 'react';
import ReactModal from 'react-modal';
import { FiAlertTriangle } from "react-icons/fi";

import '../../styles/tarjetaContenedor.css'
const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: '5px 5px 5px black',
      zIndex:'100'
    }
  };

/**
 * Componente que contiene los elementos relacionados al modal de error de acceso
 * @param {Object} param0 Recibe un objeto con el mensaje a mostrar, si el modal es visible y la función para ocultar el modal
 * @returns Component Devuelve el componente con los elementos requeridos
 */
const LoginModal = ({message,isVisible,hideModal}) => {

    //Estado que almacena si el moda es visible o no
    const [isOpen, setIsOpen] = useState(isVisible)

    /**
     * Función que cambia el estado del modal a oculto
     */
    const closeModal = () => {
        setIsOpen(false);
        hideModal()
      };

    /**
    * Función que atrapa el evento click de aceptar y dispara el cierre del modal
    * @returns Devuelve el estado del objeto
    */
    const handleCancelarClick = () => (event) => {
        event.preventDefault()
        closeModal()
    }

    return(
        <ReactModal isOpen={isOpen} style={customStyles}>
            <form id="msform" method='post'>
                <FiAlertTriangle style={{color: '#FFBF00', fontSize: '70px'}}/>  
                <h2 className="itemblogTitle">{"Error al acceder"}</h2>
                <h3 className="info_itemblog">{message}</h3>
                <input type="button" name="previous" className="previous action-button" value="Aceptar" onClick={handleCancelarClick()}/>
            </form>
        </ReactModal>
    )
}

ReactModal.setAppElement('#root')
export default LoginModal;